import Vue, { VueConstructor } from "vue";
import CollapsibleTile from "./collapsible-tile/CollapsibleTile.vue";
import HelperInfoButton from "./helper-info-button/HelperInfoButton.vue";
import ModalView from "./modal-view/ModalView.vue";
import NavBarItem from "./navbar-item/NavbarItem.vue";
import NavBar from "./navbar/Navbar.vue";
import Navigation from "./navigation/Navigation.vue";
import TileButton from "./tile-button/TileButton.vue";
import TileContainer from "./tile-container/TileContainer.vue";
import TileIcon from "./tile-icon/TileIcon.vue";
import Tile from "./tile/Tile.vue";
import NavigationPager from "./navigation-pager/NavigationPager.vue";
import WebComponents from "@abaco/web-components/src/components/index";

Vue.use(WebComponents);

export const NavbarBus = new Vue({});

const allComponents: { [key: string]: VueConstructor<Vue> } = {
    CollapsibleTile,
    HelperInfoButton,
    ModalView,
    NavBar,
    NavBarItem,
    Navigation,
    NavigationPager,
    Tile,
    TileButton,
    TileContainer,
    TileIcon
};

function install(vue: VueConstructor<Vue>): void {
    Object.keys(allComponents).forEach(k => {
        vue.component(k, allComponents[k]);
    });
}

export default { install };
